export default __webpack_public_path__ + "static/media/adidasCover.77e89b1e.jpg";